import { Archive } from 'lucide-react';
import styles from './ArchiveButton.module.css';

export default function ArchiveButton({ confirmMessage, onConfirm, disabled, loading }) {
  const handleClick = () => {
    if (!window.confirm(confirmMessage)) return;
    onConfirm();
  };

  return (
    <button
      type="button"
      className={styles.archiveBtn}
      onClick={handleClick}
      disabled={disabled || loading}
    >
      <Archive size={14} strokeWidth={1.5} />
      {loading ? 'Archiving…' : 'Archive'}
    </button>
  );
}
